<template>
  <div class="theme-card" :class="{ titled, 'no-padding': noPadding }"  @click="eventClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Divcard",
  props: {
    titled: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    eventClick() {
      this.$emit("onClick");
    },
  }
}
</script>

<style scoped lang="scss">
.theme-card {
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  background: #fff;
  padding: 24px;
  position: relative;
  .card-part:not(:last-child) {
    border-bottom: solid 1px var(--theme-color-nine);
    margin: 0 -24px;
    padding: 24px;
  }
  .card-part:first-child {
    padding-top: 0;
  }
  .card-part:last-child {
    padding-top: 24px;
  }
  .card-part-orange:not(:last-child) {
    border-bottom: solid 1px var(--theme-color-one);
    margin: 0 -24px;
    padding: 24px;
  }
  .card-part-orange2:not(:last-child) {
    border-bottom: solid 1px var(--theme-color-one);
    margin: 0 -24px;
    padding:0px 24px 16px 24px;
  }
}
.titled > .card-part:first-child > *:first-child {
  border-bottom: solid 1px var(--theme-color-one);
  margin: 0 -24px;
  padding: 0 24px 12px 24px;
}
.no-padding{
  padding: 0 !important;
}
</style>